import { ASSETS, ASSETS_BASE_URL } from '@/constants/environment'
import { AppConfig } from './sub-apps'
import { VueConstructor } from 'vue'
import Layout from './layout/mkt-layout/index.vue'

import { mergedHighlightUrlMap as mktHighlightMap } from '@/layout/mkt-layout/highlight-url-map'

function genActiveRule(routerPrefix: string | RegExp) {
  return (location: Location) =>
    typeof routerPrefix === 'string' ? location.pathname.startsWith(routerPrefix) : routerPrefix.test(location.pathname)
}

export type ShellMode = 'MKT'

export type ShellConfigs = {
  mode: ShellMode
  layout: VueConstructor<Vue>
  subApps: AppConfig[]
  defaultMountApp: string
  highlightMap: typeof mktHighlightMap
  i18nPrefix: string
  guidance: VueConstructor<Vue> | string
  initSocket: boolean
  novice?: boolean
}

const CONFIGS_MAP: Record<ShellMode, ShellConfigs> = {
  MKT: {
    mode: 'MKT',
    layout: Layout,
    subApps: [
      {
        name: 'SUB_APP__CMS',
        assetsURL: ASSETS.CMS,
        assetsBaseURL: ASSETS_BASE_URL.CMS,
        activeRule: genActiveRule('/cms'),
        routeBase: '/cms',
        precache: 'none',
      },
      {
        name: 'SUB_APP__TARGET',
        assetsURL: ASSETS.TARGET,
        assetsBaseURL: ASSETS_BASE_URL.TARGET,
        activeRule: genActiveRule('/target'),
        routeBase: '/target',
        precache: 'none',
      },
      {
        name: 'SUB_APP__TALK',
        assetsURL: ASSETS.TALK,
        assetsBaseURL: ASSETS_BASE_URL.TALK,
        activeRule: genActiveRule('/talk'),
        routeBase: '/talk',
        precache: 'none',
      },
    ],
    defaultMountApp: '/target/',
    highlightMap: mktHighlightMap,
    i18nPrefix: 'cms.',
    guidance: '',
    initSocket: true,
  },
}

const getShellConfig = () => CONFIGS_MAP.MKT

export const shellConfig = getShellConfig()
